<script setup>
  import DashboardBmpImportExclusiveWidget from "@pages/Dashboard/Components/BmpImportExclusiveWidget.vue";
  import DashboardClaim from "@pages/Dashboard/Components/Claim.vue";
  import DashboardFirstStepsWidgetWide from "@pages/Dashboard/Components/FirstStepsWidgetWide.vue";
  import DashboardHeroImage from "@pages/Dashboard/Components/HeroImage.vue";
  import DashboardPatientCountWidget from "@pages/Dashboard/Components/PatientCountWidget.vue";
  import DashboardPatientInputWidget from "@pages/Dashboard/Components/PatientInputWidget.vue";
  import DashboardQuickStartExclusiveWidget from "@pages/Dashboard/Components/QuickStartExclusiveWidget.vue";

  defineOptions({
    name: "ComponentDashboard",
  });
</script>

<template>
  <div class="pb-16">
    <div class="mx-auto mt-4 grid grid-cols-12 gap-8">
      <div class="col-span-12 grid grid-rows-2 gap-4 md:col-span-6 lg:col-span-4">
        <DashboardClaim :test-id="getTestId()" />

        <DashboardPatientCountWidget :test-id="getTestId()" />
      </div>

      <DashboardHeroImage class="col-span-6 hidden md:block lg:col-span-8" />

      <div
        v-if="$page.props.can.create_records"
        class="relative col-span-12 min-h-48 overflow-visible sm:col-span-6 lg:col-span-4"
      >
        <DashboardQuickStartExclusiveWidget class="absolute z-20 min-h-full w-full" :test-id="getTestId()" />
      </div>

      <DashboardBmpImportExclusiveWidget
        v-if="$page.props.can.create_records"
        class="col-span-12 sm:col-span-6 lg:col-span-4"
        :test-id="getTestId()"
      />

      <DashboardPatientInputWidget
        v-if="$page.props.can.view_patientinputs"
        class="col-span-12 sm:col-span-6 lg:col-span-4"
        :test-id="getTestId()"
      />

      <DashboardFirstStepsWidgetWide
        class="col-span-12 sm:col-span-6"
        :class="{
          'lg:col-span-12': $page.props.can.create_records,
          'lg:col-span-8': !$page.props.can.create_records,
        }"
        :test-id="getTestId()"
      />
    </div>
  </div>
</template>
